import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { MatMenuTrigger } from "@angular/material/menu";
import { Router } from "@angular/router";

@Component({
	selector: "app-doubts-menu",
	templateUrl: "./doubts-menu.component.html",
	styleUrls: ["./doubts-menu.component.css"]
})
export class DoubtsMenuComponent implements OnInit {
	EMPTY_NOTIFICATION = "../../../assets/icons/doubts-icon.svg";
	notifications: any[];
	iconPath: string = this.EMPTY_NOTIFICATION;
	@ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
	@Input() email: string;

	constructor(private router: Router) {}

	ngOnInit(): void {}

	redirectPageDoubts() {
		this.router.navigate(["/home/doubts"]);
	}

	closeNotification(value: number) {
		this.notifications.splice(value, 1);
		var json = JSON.stringify(this.notifications);
		localStorage.removeItem("notification");
		localStorage.setItem("notification", json);
	}
}
